<template>
    <div class="container">
        <div class="d-flex justify-content-between align-items-center mb-4">
            <div>
                <h2 class="mb-0">{{ id ? 'Modifier' : 'Créer' }} un utilisateur</h2>
                <small class="text-muted">{{ id ? 'Modifiez les informations de l\'utilisateur' : 'Ajoutez un nouvel utilisateur au système' }}.</small>
            </div>
        </div>

        <div class="card p-4 shadow-sm">
            <UserForm @saved="goToUser" @edited="goToUser" :item="user" :user_id="id" />
        </div>
    </div>
</template>

<script>
import UserForm from '@/components/forms/UserForm.vue';

export default {
    name: 'UserCreate',
    components: {
        UserForm,
    },
    props: {
        id: {
            type: [String, Number],
            default: null,
        }
    },
    data() {
        return {
            user: null,
        }
    },
    methods: {
        goToUser(user) {
            this.$router.push({ name: 'users.view', params: { id: user.id } });
        },
        getUser() {
            if (this.id) {
                this.$api.get(`/users/${this.id}`)
                    .then(response => {
                        this.user = response.data.data;
                    })
                    .catch(error => {
                        console.error('There was an error fetching the user!', error);
                    });
            }
        }   
    },
    created() {
        this.getUser();
    }
};
</script>
